<span #ref>
  <ng-content></ng-content>
</span>

<ng-container *ngIf="hasContent === false">
  <span>--</span>
</ng-container>
